import { z } from "zod";

/**
 * The ERP assistant: a conversation with a language model that reads the guide and calls the ERP's
 * own API with the user's session. Reads run at once; every change waits for the user's « Exécuter ».
 */
export const ASSISTANT_STATUSES = ["idle", "thinking", "awaiting", "failed"] as const;
export type AssistantStatus = (typeof ASSISTANT_STATUSES)[number];

/** A change the model asked for, shown to the user before anything is written. */
export interface AssistantPendingAction {
  method: string;
  path: string;
  query: Record<string, string> | null;
  body: unknown;
  /** The model's own description of the change, in the user's language. */
  summary: string;
}

/** What the conversation screen draws, built from the stored model messages. */
export type AssistantEntry =
  | { kind: "user"; text: string }
  | { kind: "assistant"; text: string }
  | { kind: "guide"; query: string }
  | { kind: "read"; method: string; path: string; status: number | null }
  | {
      kind: "action";
      method: string;
      path: string;
      summary: string;
      /** done/failed once run, refused when the user declined, pending while it waits. */
      outcome: "pending" | "done" | "failed" | "refused";
      status: number | null;
    };

export const assistantMessageSchema = z.object({
  text: z.string().trim().min(1, "errors.field.required").max(8000),
});
export type AssistantMessageInput = z.input<typeof assistantMessageSchema>;

export const assistantConfirmSchema = z.object({ approve: z.boolean() });
